<template>
  <svg
    id="Icon_-_check-circle"
    data-name="Icon - check-circle"
    xmlns="http://www.w3.org/2000/svg"
    width="38.75"
    height="38.75"
    viewBox="0 0 38.75 38.75"
  >
    <path
      id="Icon_awesome-check-circle"
      data-name="Icon awesome-check-circle"
      d="M39.375,20A19.375,19.375,0,1,1,20,.625,19.375,19.375,0,0,1,39.375,20ZM17.759,30.259,32.134,15.884a1.25,1.25,0,0,0,0-1.768l-1.768-1.768a1.25,1.25,0,0,0-1.768,0L16.875,24.072,11.4,18.6a1.25,1.25,0,0,0-1.768,0L7.866,20.366a1.25,1.25,0,0,0,0,1.768l8.125,8.125A1.25,1.25,0,0,0,17.759,30.259Z"
      transform="translate(-0.625 -0.625)"
      fill="#7feb4a"
    />
  </svg>
</template>
